(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function containsAnyLetter(str) {
  return /[a-zA-Z]/.test(str);
}

function containsAnyNumber(str) {
  return /[0-9]/.test(str);
}

function containsAnySpecialChar(str) {
  return /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(str);
}

var CreateAccount = function CreateAccount(element) {
  var _this2 = this;

  _classCallCheck(this, CreateAccount);

  _defineProperty(this, "setupValidation", function () {
    var messages = $(_this2.formElement).data("messages");
    messages = decodeURIComponent(messages);
    messages = JSON.parse(messages);
    _this2.bouncerValidate = new Bouncer("#".concat(_this2.formElement.getAttribute('id')), {
      // Error messages by error type
      customValidations: {
        valueMismatch: function valueMismatch(field) {
          var selector = field.getAttribute('data-bouncer-match');
          if (!selector) return false;
          var otherField = field.form.querySelector(selector);
          if (!otherField) return false;
          return otherField.value !== field.value;
        },
        passCheck: function passCheck(field) {
          var selector = field.getAttribute('data-bouncer-pass');
          if (!selector) return false;
          var error = false;

          if (field.value.length < 8) {
            error = true;
          }

          if (!(containsAnyLetter(field.value) && containsAnyNumber(field.value))) {
            error = true;
          }

          if (!containsAnySpecialChar(field.value)) {
            error = true;
          } // console.log(error)


          return error;
        }
      },
      messages: messages
    });
    $("#".concat(_this2.formElement.getAttribute('id'), " .input__field--classic input")).blur(function () {
      $(this).parent().addClass("valid");
    });
  });

  _defineProperty(this, "setupPasswordCheck", function () {
    $("#".concat(_this2.formElement.getAttribute('id'), " .disp_pass")).click(function (event) {
      event.preventDefault(); // console.log("disp")

      $(this).toggleClass("visible");
      var input = $(this).parent().find("input").first();

      if (input.attr("type") == "password") {
        input.attr("type", "text");
      } else {
        input.attr("type", "password");
      }
    });
    $("#".concat(_this2.formElement.getAttribute('id'), " #passwd")).keyup(function () {
      var val = $(this).val();

      if (val.length >= 8) {
        $(this).parent().parent().find("#nbchar").addClass("valid");
      } else {
        $(this).parent().parent().find("#nbchar").removeClass("valid");
      }

      if (containsAnyLetter(val) && containsAnyNumber(val)) {
        $(this).parent().parent().find("#numandletter").addClass("valid");
      } else {
        $(this).parent().parent().find("#numandletter").removeClass("valid");
      }

      if (containsAnySpecialChar(val)) {
        $(this).parent().parent().find("#specialchar").addClass("valid");
      } else {
        $(this).parent().parent().find("#specialchar").removeClass("valid");
      }
    });
  });

  _defineProperty(this, "onFormSubmit", function () {
    var _this = _this2;
    $("#".concat(_this2.formElement.getAttribute('id'), " .createAccount__submit")).click(function (event) {
      event.preventDefault();
      var form = document.querySelector("#".concat(_this.formElement.getAttribute('id')));

      var valid = _this.bouncerValidate.validateAll(form);

      if (!valid.length) {
        var _event = new Event('formIsValid');

        document.dispatchEvent(_event);
      } else {
        $([document.documentElement, document.body]).animate({
          scrollTop: $(form).find(".error-message").first().offset().top - 200
        }, 2000);
      }
    });
  });

  $(element).addClass("initialized");
  this.formElement = element;
  this.bouncerValidate = null;
  this.setupPasswordCheck();
  this.setupValidation();
  this.onFormSubmit();
};

window.addEventListener('DOMContentLoaded', function () {
  var createAccounts = document.querySelectorAll('.createAccount:not(.initialized)'); // console.log(createAccounts)

  if (createAccounts) {
    createAccounts.forEach(function (element) {
      //new CreateAccount(element);
    });
  }
});

},{}]},{},[1])